import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "react-bootstrap";
import { FiGrid, FiUsers, FiLink, FiFileText, FiBell } from "react-icons/fi";
import {
  BsList,
  BsDot,
  BsListTask,
  BsClipboardData,
  BsChevronDown,
  BsBell,
  BsFillPersonFill,
  BsWrench,
  BsBootstrapReboot,
} from "react-icons/bs";
import { AiOutlineDeliveredProcedure, AiOutlineFileDone } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { Pill } from "evergreen-ui";

import * as userAuthActions from "../../Redux/Actions/user";
import * as localizationActions from "../../Redux/Actions/localization";
import { toastMessage } from "../../utils/toast";
import { getLocaleValue } from "../../utils";
import { clearSession } from "../../utils/initiate";
// import NotificationList from '../Notification';
import JobRequest from "./jobRequest";
import * as notificationActions from "../../Redux/Actions/notifications";
import DeleteModal from "../Ui/DeleteModal/DeleteModal";
import { getToken } from "../../utils/pushNotification";
import { updateToken } from "../../Redux/Actions/notification";

import "./scrollable.css";

const SideNavigation = ({ children, history }) => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("dashboard");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  //   const [showMenu, setShowMenu] = useState(
  //     window.innerWidth > 1050 ? false : true
  //   );
  const [showMenu, setShowMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isArabic, setIsArabic] = useState(
    localStorage.getItem("i18nextLng") === "arabic"
  );
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const pathName = window.location.pathname;
  const [fcmToken, setFcmToken] = useState("");
  const [unReadNotificationCount, setUnReadNotificationCount] = useState(0);
  const [logoutButtonLoading, setLogoutButtonLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth > 1025 ? false : true
  );

  const NotificationFetchIntervlInMilliSeconds = 60000;

  const userData = useSelector(({ User }) => User.data);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 1025); // Set breakpoint at 768px
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (userData.Role === "CUSTOMER") {
      handleUnreadNotificationCount();
    }
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      if (userData.Role === "CUSTOMER") {
        handleUnreadNotificationCount();
      }
    }, NotificationFetchIntervlInMilliSeconds);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [selectedCategory]);

  useEffect(() => {
    if (pathName === "/users" || pathName === "/users/add") {
      setSelectedCategory("users");
    } else if (pathName.includes("master")) {
      setSelectedCategory("masters");
    }

    let selectedValue = window.location.pathname.split("/");
    if (pathName.includes("process-cost")) {
      setSelectedSubCategory(selectedValue[2]);
    } else if (
      pathName.includes("department") ||
      pathName.includes("master-process") ||
      pathName.includes("process")
    ) {
      setSelectedSubCategory(selectedValue[3]);
    }

    if (pathName === "/documents") {
      setSelectedCategory("documents");
    }
  }, [pathName]);
  // handleUserLogout
  const handleUserLogout = () => {
    setShowUserMenu(false);
    setLogoutButtonLoading(false);
    userAuthActions
      .userLogout({ Id: userData.UserId })
      .then((res) => {
        if (res.status === 200) {
          dispatch(userAuthActions.userAuthLogout());
          localStorage.removeItem("jwt");
          localStorage.removeItem("fcmToken");
          history.push("/");
        } else {
          toastMessage("error", "Logout Failed");
        }
      })
      .catch((err) => {
        dispatch(userAuthActions.userAuthLogout());
        localStorage.removeItem("jwt");
        history.push("/");
      });
  };

  useEffect(() => {
    setTimeout(() => {
      let token = localStorage.getItem("fcmToken");
      if (token == "" || token == null) {
        askNotificationPermission();
      }
    }, 2000);
  }, [fcmToken]);

  // useEffect(() => {
  //   if (Notification.permission == "denied") {
  //     localStorage.removeItem("fcmToken");
  //   }
  //   if(Notification.permission == "default"){
  //     askNotificationPermission();

  //   }

  // }, []);

  setTimeout(() => {
    const interval = setInterval(() => { 
      if (Notification.permission == "denied") {
        PermissionNotGiven();
      }
      if(Notification.permission == "default"){
        askNotificationPermission();
      }

    }, 30000);

    return () => clearInterval(interval);
  });

  const PermissionNotGiven = () => {
    if (Notification.permission == "denied") {
      // Notification.requestPermission();
      toastMessage("error", "Please, give permission for Notification");
    }
  };

  const askNotificationPermission = () => {
    let oldToken = localStorage.getItem("fcmToken");
    // Notification.requestPermission((result) => {
    //   console.log(result);
    // });
    Notification.requestPermission().then((permission) => {
      if (permission == "granted") {
        getToken(setFcmToken);

        let payload = {
          fcmToken,
          id: userData?.UserId,
        };

        if (
          (oldToken == "" || oldToken == null || oldToken != fcmToken) &&
          fcmToken != ""
        ) {
          updateToken(payload).then((res) => {
            localStorage.setItem("fcmToken", fcmToken);
            if (res && res.data) {
              toastMessage("success", "Your notification status updated");
            } else {
              toastMessage("error", "Unable to update the FCM token");
            }
          });
        }
      }else if(permission == "denied"){
        localStorage.removeItem("fcmToken");
      }
    });
  };

  // const broadcast = new BroadcastChannel("count-channel");
  // broadcast.onmessage = (event) => {
  //   if(event?.data?.data?.type == "AWAITING_RESPONSE"){
  //     history.push(`/additionalPayment/${event.data.data.job_ID}`);
  //   }
  // };

  const changeLanguage = (value) => {
    setIsArabic(value);
    i18n.changeLanguage(value ? "arabic" : "english");
  };
  const handleUnreadNotificationCount = () => {
    if (userData.Role === "CUSTOMER") {
      notificationActions
        .getUnreadNotificationCount()
        .then(({ data }) => {
          if (data) {
            setUnReadNotificationCount(data);
          } else {
            setUnReadNotificationCount(0);
          }
        })
        .catch((err) => {
          console.log(err);
          // toastMessage(
          //   "error",
          //   (err && err.message) || `Unable to get Notifications`
          // );
        });
    }
  };
  useEffect(() => {
    // add event listener to detect clicks outside of dropdown
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // remove event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      // if click outside dropdown, close it
      setShowUserMenu(false);
    }
  };
  useEffect(() => {}, [window.innerWidth, showMenu]);

  const handleLogoutClose = () => {
    setLogoutButtonLoading(false);
    setShowLogoutModal(false);
  };

  useEffect(() => {
    if (localStorage.getItem("localAr") === null) {
      //To Get English Localizations
      localizationActions
        .localization("EN")
        .then((res) => {
          if (res) {
            localStorage.setItem("localEn", JSON.stringify(res));
            changeLanguage("english");
          } else {
            localStorage.setItem("localEn", "");
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the eng Localization`
            );
          }
        })
        .catch((err) => {
          err.response?.status === 401 && clearSession(dispatch, history);
        });
      //-----------------------------------------------------------------------------------------------------
      //To Get Arabic Localizations
      localizationActions
        .localization("AR")
        .then((res) => {
          if (res) {
            localStorage.setItem("localAr", JSON.stringify(res));
          } else {
            localStorage.setItem("localAr", "");
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the ar Localization`
            );
          }
        })
        .catch((err) => {
          err.response?.status === 401 && clearSession(dispatch, history);
        });
    }
  }, []);
  return (
    <div style={{ width: "100vw", overflow: "hidden" }}>
      <div
        className="left-sidenav"
        style={{ display: showMenu && "none", top: 0 }}
      >
        <div
          style={{
            position: "relative",
            zIndex: "1002",
            textAlign: "center",
            top: 0,
            left: 0,
          }}
        >
          <img
            src={"/Assets/aamer_logo.jpg"}
            alt="Logo"
            className="logo logo-lg"
            style={{ width: "130px", height: "auto" }}
          />
        </div>
        <div className="menu-content h-100">
          <ul
            className="metismenu left-sidenav-menu"
            style={{ padding: 0, cursor: "pointer" }}
          >
            {userData.Role === "SUPERADMIN" || userData.Role === "SUBADMIN" || (
              <li
                style={{ marginTop: "1px" }}
                onClick={() => {
                  window.location.pathname.includes("home") &&
                    window.location.reload();
                  history.push("/home");
                  setSelectedCategory("dashboard");
                  handleUnreadNotificationCount();
                }}
              >
                <Card
                  style={{
                    backgroundColor: "#2d207d",
                    height: "55px",
                    borderRadius: 0,
                    marginBottom: 0,
                  }}
                >
                  <img
                    src="/Assets/ion_home.svg"
                    height={"30px"}
                    width={"30px"}
                    style={{ margin: "auto" }}
                  />
                </Card>
                {/* <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/home') && 'text-info')}> 
                                <FiGrid className="font-20 me-lg-2" /><span>{t("sideNav.services")}</span>
                            </p> */}
              </li>
            )}{" "}
            {
              <li
                style={{ marginTop: "1px" }}
                onClick={() => {
                  history.push("/notifications");
                  setSelectedCategory("notifications");
                }}
              >
                <Card
                  style={{
                    backgroundColor: "#2d207d",
                    height: "55px",
                    borderRadius: 0,
                    marginBottom: 0,
                  }}
                >
                  {/* <div style={{margin: 'auto'}}> */}
                  <span
                    style={{ position: "absolute", top: "5px", left: "80px" }}
                  >
                    <span style={{ marginLeft: "50px" }}>
                      {unReadNotificationCount > 0 && (
                        <Pill color="#b71c1c">{unReadNotificationCount}</Pill>
                      )}
                    </span>
                  </span>

                  {/* </div>  */}

                  <img
                    src="/Assets/mail.svg"
                    height={"30px"}
                    width={"30px"}
                    style={{ margin: "auto" }}
                  />
                </Card>
                {/* <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/documentVault') && 'text-info')}> 
                            <FiFileText className="font-20  me-lg-2" /><span>{t("sideNav.documentWallet")}</span>
                            </p> */}
              </li>
            }
            {
              <li
                style={{ marginTop: "1px" }}
                onClick={() => {
                  history.push("/setting");
                  setSelectedCategory("settings");
                }}
              >
                <Card
                  style={{
                    backgroundColor: "#2d207d",
                    height: "55px",
                    borderRadius: 0,
                    marginBottom: 0,
                  }}
                >
                  <img
                    src="/Assets/setting.svg"
                    height={"30px"}
                    width={"30px"}
                    style={{ margin: "auto" }}
                  />
                </Card>
                {/* <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/documentVault') && 'text-info')}> 
                            <FiFileText className="font-20  me-lg-2" /><span>{t("sideNav.documentWallet")}</span>
                            </p> */}
              </li>
            }
            {
              <li
                style={{ marginTop: "1px" }}
                onClick={() => {
                  history.push("/documentVault");
                  setSelectedCategory("documentWallet");
                }}
              >
                <Card
                  style={{
                    backgroundColor: "#2d207d",
                    height: "55px",
                    borderRadius: 0,
                    marginBottom: 0,
                  }}
                >
                  <p
                    className={
                      "c-pointer my-3 d-flex align-items-center " +
                      (pathName === "/documentVault" && "text-info")
                    }
                  >
                    <span
                      style={{
                        color: "white",
                        fontSize: "15px",
                        margin: "auto",
                      }}
                    >
                      {t("sideNav.documentWallet")}
                    </span>
                  </p>
                </Card>
              </li>
            }
            {userData.Role === "SUPERADMIN" && (
              <li
                onClick={() => {
                  setSelectedCategory("masters");
                  handleUnreadNotificationCount();
                }}
              >
                <div
                  className={
                    "c-pointer my-4 d-flex align-items-center justify-content-between " +
                    (pathName === "/masters" && "text-info")
                  }
                >
                  <p>
                    <FiLink className="font-20 me-lg-2" />
                    <span>{t("sideNav.mastersManagement.title")}</span>
                  </p>
                  <BsChevronDown />
                </div>
                {selectedCategory === "masters" && (
                  <ul className="nav-second-level">
                    <li onClick={() => setSelectedSubCategory("department")}>
                      <div
                        className={
                          "c-pointer my-4 d-flex align-items-center justify-content-between " +
                          (selectedSubCategory === "department" && "text-info")
                        }
                      >
                        <p>
                          {t("sideNav.mastersManagement.departments.title")}
                        </p>
                        <BsChevronDown />
                      </div>
                      {selectedSubCategory === "department" || (
                        <ul className="nav-second-level">
                          <li
                            className={
                              "c-pointer nav-link mt-lg-n2 " +
                              (pathName === "/master/add/department" &&
                                "active")
                            }
                            onClick={() =>
                              history.push("/master/add/department")
                            }
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.departments.add")}
                          </li>
                          <li
                            className={
                              "c-pointer nav-link " +
                              (pathName === "/master/manage/department" &&
                                "active")
                            }
                            onClick={() =>
                              history.push("/master/manage/department")
                            }
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.departments.manage")}
                          </li>
                        </ul>
                      )}
                    </li>
                    <li
                      onClick={() => {
                        setSelectedSubCategory("master-process");
                        handleUnreadNotificationCount();
                      }}
                    >
                      <div
                        className={
                          "c-pointer my-4 d-flex align-items-center justify-content-between " +
                          (selectedSubCategory === "master-process" &&
                            "text-info")
                        }
                      >
                        <p>
                          {t("sideNav.mastersManagement.masterProcess.title")}
                        </p>
                        <BsChevronDown />
                      </div>
                      {selectedSubCategory === "master-process" && (
                        <ul className="nav-second-level">
                          <li
                            className={
                              "c-pointer nav-link mt-lg-n2 " +
                              (pathName === "/master/add/master-process" &&
                                "active")
                            }
                            onClick={() => {
                              history.push("/master/add/master-process");
                              handleUnreadNotificationCount();
                            }}
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.masterProcess.add")}
                          </li>
                          <li
                            className={
                              "c-pointer nav-link " +
                              (pathName === "/master/manage/master-process" &&
                                "active")
                            }
                            onClick={() => {
                              history.push("/master/manage/master-process");
                              handleUnreadNotificationCount();
                            }}
                          >
                            <BsDot />
                            {t(
                              "sideNav.mastersManagement.masterProcess.manage"
                            )}
                          </li>
                        </ul>
                      )}
                    </li>
                    <li
                      onClick={() => {
                        setSelectedSubCategory("process");
                        handleUnreadNotificationCount();
                      }}
                    >
                      <div
                        className={
                          "c-pointer my-4 d-flex align-items-center justify-content-between " +
                          (selectedSubCategory === "process" && "text-info")
                        }
                      >
                        <p>{t("sideNav.mastersManagement.process.title")}</p>
                        <BsChevronDown />
                      </div>
                      {selectedSubCategory === "process" && (
                        <ul className="nav-second-level">
                          <li
                            className={
                              "c-pointer nav-link mt-lg-n2 " +
                              (pathName === "/master/add/process" && "active")
                            }
                            onClick={() => history.push("/master/add/process")}
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.process.add")}
                          </li>
                          <li
                            className={
                              "c-pointer nav-link " +
                              (pathName === "/master/manage/process" &&
                                "active")
                            }
                            onClick={() =>
                              history.push("/master/manage/process")
                            }
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.process.manage")}
                          </li>
                        </ul>
                      )}
                    </li>
                    <li onClick={() => setSelectedSubCategory("process-cost")}>
                      <div
                        className={
                          "c-pointer my-4 d-flex align-items-center justify-content-between " +
                          (selectedSubCategory === "process-cost" &&
                            "text-info")
                        }
                      >
                        <p>
                          {t("sideNav.mastersManagement.processCost.title")}
                        </p>
                        <BsChevronDown />
                      </div>
                      {selectedSubCategory === "process-cost" && (
                        <ul className="nav-second-level">
                          <li
                            className={
                              "c-pointer nav-link mt-lg-n2 " +
                              (pathName === "/master/process-cost/add" &&
                                "active")
                            }
                            onClick={() =>
                              history.push("/master/process-cost/add")
                            }
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.processCost.add")}
                          </li>
                          <li
                            className={
                              "c-pointer nav-link " +
                              (pathName === "/master/process-cost/manage" &&
                                "active")
                            }
                            onClick={() =>
                              history.push("/master/process-cost/manage")
                            }
                          >
                            <BsDot />
                            {t("sideNav.mastersManagement.processCost.manage")}
                          </li>
                        </ul>
                      )}
                    </li>
                  </ul>
                )}
              </li>
            )}
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/jobs");
                setSelectedCategory("jobs");
                // handleUnreadNotificationCount();
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {getLocaleValue("home_drawer_jobs")}
                  </span>
                </p>
              </Card>
            </li>
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/paydueslist");
                setSelectedCategory("paydues");
                // handleUnreadNotificationCount();
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/paydueslist" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {getLocaleValue("additional_payments")}
                  </span>
                </p>
              </Card>
            </li>
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/flyerNotifications");
                setSelectedCategory("flyerNofications");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {getLocaleValue("home_drawer_flyerNotices")}
                  </span>
                </p>
              </Card>
            </li>
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                setShowLogoutModal(true);
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <img
                    src="/Assets/login.png"
                    height={"30px"}
                    width={"30px"}
                    style={{ margin: "auto" }}
                  />
                </p>
              </Card>
            </li>
            {/* {(userData.Role === 'SUPERADMIN') && <li onClick={() => {history.push('/reports'); setSelectedCategory('reports'); handleUnreadNotificationCount();}}>
                            <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/reports') && 'text-info')}><BsClipboardData className="font-20  me-lg-2" /><span>{t("sideNav.reports")}</span>
                            <span className="menu-arrow"><i className="mdi mdi-chevron-right"></i></span></p>
                        </li>} */}
          </ul>
        </div>
      </div>

      <div
        className="page-wrapper"
        style={{ overflowX: "auto", marginLeft: isMobile ? "230px" : "" }}
      >
        <div className="topbar" ref={ref} style={{ position: "inherit" }}>
          <nav className="navbar-custom">
            <ul className="list-unstyled topbar-nav float-end mb-0 d-flex align-items-center">
              <li className="form-switch form-switch-secondary">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="customSwitchSecondary"
                  checked={isArabic}
                  onChange={(e) => changeLanguage(e.target.checked)}
                  style={{ cursor: "pointer", backgroundColor: "#b71c1c" }}
                />
                <label
                  className="form-check-label ps-2 pe-3"
                  htmlFor="customSwitchSecondary"
                  style={{ cursor: "pointer", color: "#b71c1c" }}
                >
                  Arabic
                </label>
              </li>

              {/* { <li onClick={() => {history.push('/notifications'); setSelectedCategory('notifications'); handleUnreadNotificationCount();}} className="dropdown notification-list">
                                <p className="nav-link dropdown-toggle arrow-none waves-light waves-effect">
                                    <BsBell className="font-20" />
                                </p>
                            </li>} */}

              <li className="dropdown">
                <p
                  className="nav-link dropdown-toggle waves-effect waves-light nav-user"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <span className="me-2 nav-user-name">{userData.Name}</span>
                  <BsFillPersonFill className="font-20" />
                </p>
                <div
                  className={
                    "dropdown-menu dropdown-menu-end " +
                    (showUserMenu ? "show" : "")
                  }
                  style={{ right: "5px" }}
                >
                  {
                    <p
                      className="dropdown-item c-pointer"
                      onClick={() => {
                        history.push("/change-password");
                        setShowUserMenu(false);
                      }}
                    >
                      {t("profile.changePassword")}
                    </p>
                  }
                  <p
                    className="dropdown-item c-pointer"
                    onClick={handleUserLogout}
                  >
                    {t("profile.logout")}
                  </p>
                </div>
              </li>
              {/* { <li onClick={() => {history.push('/setting'); setSelectedCategory('setting'); }} className="dropdown notification-list">
                                <p className="nav-link dropdown-toggle arrow-none waves-light waves-effect">
                                    <BsWrench className="font-20" />
                                </p>
                            </li>} */}
            </ul>
            <ul className="list-unstyled topbar-nav mb-0">
              <li>
                {/* <button
                  className="nav-link button-menu-mobile"
                  onClick={() => {
                    setShowMenu(!showMenu);
                  }}
                >
                  <BsList className="font-20" />
                </button> */}
              </li>
            </ul>
          </nav>
        </div>
        <div className="page-content" style={{ marginTop: "0px" }}>
          {children}
          {/* <footer className="footer text-center text-sm-start">&copy; Aamer</footer> */}
        </div>
      </div>
      <JobRequest t={t} userID={userData.UserId} />
      {showLogoutModal && (
        <DeleteModal
          handleCancel={handleLogoutClose}
          showModal={showLogoutModal}
          handleOk={handleUserLogout}
          loading={logoutButtonLoading}
          footerOption1={"Logout"}
          footerOption2={"Cancel"}
          type={"logout"}
        ></DeleteModal>
      )}
    </div>
  );
};

export default SideNavigation;
